(function($) {

    $(document).on('gp_ajax_done', init_reviews)

    function init_reviews() {
        $(".add-review-product svg.stars, .add-review-order svg.stars, .sidebar-my-account-review__rating svg.stars")
            // Show the correct number of stars when hovering over them
            .on("mouseenter", function () {
                let current_rating = $(this).prevAll(".stars").length + 1
                if (current_rating) {
                    $(this).attr("fill", "#EBB845") // fill the currently hovered star

                    $(this).siblings("svg.stars").each(function () {
                        if ($(this).prevAll(".stars").length + 1 <= current_rating) {
                            $(this).attr("fill", "#EBB845") // fill all previous stars
                        } else {
                            $(this).attr("fill", "#D9D9D9") // empty all following stars
                        }
                    })
                }

                let ratingInput = $('input[type="hidden"][name="rating"]');
                if (ratingInput.length > 0) {
                    ratingInput.val(current_rating);
                }
            })

        // Empty stars when hovering outside
        $(".add-review-product svg.stars, .add-review-order svg.stars")
            .on("mouseleave", function () {
                $(this).attr("fill", "#D9D9D9")

                $(this).siblings("svg.stars").each(function () {
                    $(this).attr("fill", "#D9D9D9")
                })
            })
    }

    init_reviews()

})(jQuery);
